<div class="ea-toggle {{ name }}" [ngClass]="{ 'toggle-off': !on }">
  <span class="ea-label-left">
    <ng-content select="[start]"></ng-content>
  </span>
  <button
    type="button"
    class="ea-toggle-btn"
    (click)="onToggle($event)"
  ></button>
  <span class="ea-label-right">
    <ng-content select="[end]"></ng-content>
  </span>
</div>
